// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

global.jQuery = global.$ = require('jquery');
import * as VueGoogleMaps from 'vue2-google-maps'

import Vue from 'vue'
import App from './App'
import router from './router'
import {tr,ar, en} from './strings'
import axios from 'axios'
import vuex from 'vuex'
import VueAxios from 'vue-axios'
import  store  from "./store"
import MultiLanguage from 'vue-multilanguage'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA1nXZ9IJLDGfvPxRDuCY5P6iku3m2uJgg',
    libraries: 'places',
  }
})

require('lightgallery');
require('lg-fullscreen');
require('lg-zoom');
require('fastjs.shortcuts');
let Bootstrap = require('bootstrap')
Vue.config.productionTip = false
Vue.use(Bootstrap)
Vue.use(vuex)
Vue.use(VueAxios, axios)


Vue.use(MultiLanguage, {
	default: 'tr',
	tr: tr,
	ar: ar,
	en: en
})

import appHeader from './components/partials/Header.vue';
import appFooter from './components/partials/Footer.vue';
Vue.component('app-header', appHeader);
Vue.component('app-footer', appFooter);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js